'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationError = function ValidationError() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Validation Error';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _classCallCheck3.default)(this, ValidationError);

  this.message = message;
  this.payload = payload;
};

exports.default = ValidationError;
//# sourceMappingURL=ValidationError.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-vld/lib/ValidationError.js
// module id = 512
// module chunks = 0